import {
    buildConfigSlice,
    useConfigSlice,
    WidgetConfigSliceActionPayloadType,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import {
    initialPredictedRemainingVolumeCapsuleConfigState,
    PredictedVolumeCapsuleConfigState,
} from './PredictedVolumeCapsuleConfigState';
import { selectPredictedVolumeCapsuleState } from '../selectors';
import { useWidgetContext } from 'widgets/WidgetContext';

export const buildPredictedVolumeCapsuleConfigSlice = (
    widgetType: WidgetType
) =>
    buildConfigSlice<PredictedVolumeCapsuleConfigState>(
        widgetType,
        selectPredictedVolumeCapsuleState,
        initialPredictedRemainingVolumeCapsuleConfigState
    );

export const usePredictedVolumeCapsuleConfigSlice = () => {
    const { widgetType } = useWidgetContext();
    return useConfigSlice(buildPredictedVolumeCapsuleConfigSlice(widgetType));
};

export type PredictedVolumeCapsuleConfigPayloadType =
    WidgetConfigSliceActionPayloadType<PredictedVolumeCapsuleConfigState>;
